import angular from 'angular';

import settingsWepsterModule from '../../settings.integrations/wepster/settings.wepster.module';
import drawerModule from '../../ui/drawer/drawer.module';
import notificationModule from '../../ui/notification/notification.module';
import { chatButton } from './lead.popup.chat.button.directive';
import { messengerMenu } from './lead.popup.messenger.menu.directive';

export default angular
  .module('lead.popup.chat', [
    drawerModule.name,
    settingsWepsterModule.name,
    notificationModule.name,
  ])
  .directive('chatButton', chatButton)
  .directive('messengerMenu', messengerMenu);
